let searchTrigger = document.querySelector('.js-search-trigger');
let searchForm = document.querySelector('.js-search-form');

if(searchTrigger && searchForm){
  let input = searchForm.querySelector('input[type=search]');
  let hideBlock  = document.querySelector('.js-search-hide');
  let closeButton = document.querySelector('.js-search-close');

  let animated = document.querySelector('.js-search-animated');


  searchTrigger.setAttribute('tabindex', '0');
  searchTrigger.setAttribute('role', 'button');
  searchTrigger.setAttribute('aria-expanded', 'false');

  searchTrigger.addEventListener('click', (e) => {
    console.log('click');
    e.preventDefault();
    hideBlock.classList.add(animated ? 'search-hide' : 'hidden');
    animated ? searchForm.classList.add('search-show') : searchForm.classList.remove('hidden');
    trigger.setAttribute('aria-expanded', 'true');
    input.focus();
  });

  closeButton.addEventListener('click', (e) => {
    console.log('close');
    e.preventDefault();
    hideBlock.classList.remove(animated ? 'search-hide' : 'hidden');
    animated ? searchForm.classList.remove('search-show') : searchForm.classList.add('hidden');
    searchTrigger.setAttribute('aria-expanded', 'false');
    searchTrigger.focus();
  });
}
